<template>
  <div class="wrap">
    <!-- test -->
    <!-- <div class="">{{deviceInfo}}</div> -->
    <general-header roleType="general"></general-header>
    <router-view class="main"></router-view>
    <!-- 充值提醒弹窗 -->
    <device-dialog
      :title="$t('recharge.Recharge_reminder')"
      :width="'710px'"
      :visible.sync="controlDeviceVisible"
      :class="{
        showDialog: controlDeviceVisible,
        hideDialog: !controlDeviceVisible
      }"
    >
      <div slot="content">
        <h3 class="yujing">{{ $t("recharge.early_warning") }}</h3>
        <div class="yujingtishi">{{ $t("recharge.Content_warning") }}</div>
      </div>
      <div slot="footer" class="footBotton">
        <button class="button-hollow button1" @click="controlDeviceVisible = false">{{ $t("recharge.not_for_the_time_being") }}</button>
        <button class="button-solid button" @click="submitEditDevice1">{{ $t("recharge.Recharge_now") }}</button>
      </div>
    </device-dialog>
  </div>
</template>
<script>
import generalHeader from "@/views/headernew"
import deviceDialog from "@/components/dialognew"
// import { mapGetters } from 'vuex';
export default {
  components: {
    generalHeader,
    deviceDialog
  },
  data() {
    return {
      controlDeviceVisible: false
    }
  },
  mounted() {
    this.queryAccountInfo()
    this.flowExpirationDetection1()
  },
  // 关于登录后首页显示问题
  // computed: {
  //   ...mapGetters({
  //     deviceInfo: 'getDeviceInfo'
  //   }),
  // },
  // watch: {
  //   deviceInfo: {
  //     handler (val) {
  //       console.log('deviceInfo', val)
  //       if(val.pn) {
  //         this.showSidebar = true
  //         this.shownComponent = 'deviceDetail'
  //       } else {
  //         this.showSidebar = false
  //         // this.shownComponent = 'deviceOverview'
  //         // 空设备
  //         // this.shownComponent = 'deviceNo'
  //         this.$router.push({path:'/generalNew/deviceno'})
  //       }
  //     },
  //     deep: true
  //   },
  // },
  methods: {
    submitEditDevice1() {
      this.$router.push({
        path: "/generalNew/setting/rechargePay"
      })
      this.controlDeviceVisible = false
    },
    flowExpirationDetection1() {
      this.$request.get("flowExpirationDetection").then(res => {
        if (res.err == 0 && res.dat.total > 0) {
          this.controlDeviceVisible = true
        }
      })
    },
    // 获取用户信息
    queryAccountInfo() {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err === 0) {
          this.$store.commit("saveUserInfo", {
            username: res.dat.usr,
            avatar: res.dat.photo
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
// @import url("../../assets/css/mixin.less");
.wrap {
  height: 100%;
  display: flex;
  flex-direction: column;

  // [XM布局调整]
  // overflow-x: auto;
  .main {
    flex: 1;
    display: flex;
    overflow: hidden;
    // background: #f0f0f0;
    background: #2a404a;
    // [XM布局调整]
    // min-width: 1440px;
  }

  /deep/.yujing {
    color: #ec9630;
    padding-bottom: 25px;
  }

  /deep/.yujingtishi {
    font-size: 14px;
    color: #a3c7d7;
  }

  /deep/.dialog-footer {
    border-top: 0px !important;
  }

  /deep/.footBotton .button1 {
    border: #16d09a 1px solid !important;
    color: #16d09a !important;
    background-color: transparent !important;

    &:hover {
      background: #16d09a !important;
      color: #222d35 !important;
    }
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
}

// Loading
.el-loading-spinner .path {
  stroke: @primaryTextColor !important;
}
</style>
<style lang="less">
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  // font-weight: 100;
  font-family: Microsoft YaHei;
}
</style>